// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_descriptors.js
 **/